import { API_V1 } from "../config/main-axios";

class Metrics {
  getAll(data) {
    return API_V1.get("/metrics/admin/metrics/", {
      params: data,
    });
  }

  getById(id) {
    return API_V1.get(`/metrics/admin/metrics/${id}/`);
  }

  create(data) {
    return API_V1.post("/metrics/admin/metrics/", data);
  }

  update(id, data) {
    return API_V1.patch(`/metrics/admin/metrics/${id}/`, data);
  }

  delete(id) {
    return API_V1.delete(`/metrics/admin/metrics/${id}/`);
  }

  getUserMetrics(userId) {
    return API_V1.get("/metrics/admin/user-metrics/", {
      params: { user__id: userId },
    });
  }
}

export default new Metrics();
